import { emit } from "@tauri-apps/api/event";
import { getCurrentWindow } from "@tauri-apps/api/window";
import { isDesktopOverlayWindow } from "@/desktop/desktop-overlay-window";

/** A desktop window entered Workspace; windows on other displays yield it. */
export const WORKSPACE_MODE_CLAIMED_EVENT = "workspace-mode-claimed";
/** A desktop window left Workspace, or loaded without one. Rust also sends it
 *  for the window of an unplugged display. */
export const WORKSPACE_MODE_RELEASED_EVENT = "workspace-mode-released";
/** A window that just loaded asks the current holder to claim again. */
export const WORKSPACE_MODE_QUERY_EVENT = "workspace-mode-query";

export interface WorkspaceModeEventPayload {
  displayId: number | null;
  windowLabel: string;
}

/** Announce this window's Workspace state to every desktop window. */
export function emitWorkspaceModeEvent(
  event:
    | typeof WORKSPACE_MODE_CLAIMED_EVENT
    | typeof WORKSPACE_MODE_RELEASED_EVENT
    | typeof WORKSPACE_MODE_QUERY_EVENT,
): void {
  if (!isDesktopOverlayWindow()) return;
  const displayId = (window as unknown as { __DENKER_DISPLAY_ID__?: number })
    .__DENKER_DISPLAY_ID__;
  const payload: WorkspaceModeEventPayload = {
    displayId: typeof displayId === "number" ? displayId : null,
    windowLabel: getCurrentWindow().label,
  };
  void emit(event, payload).catch(() => {});
}
